import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import SelectField from "../../../../shared/components/fields/selectField/SelectField";
import {I18n} from 'react-redux-i18n';
import _ from "../../../../shared/utils/ObjectUtils";
import IconButton from "../../../../shared/components/others/IconButton";
import arrowDownWhite from "../../../../shared/img/arrow-down-white.svg";
import deleteButton from "../../../../shared/img/delete-button-white.svg";
import addButton from "../../../../shared/img/add-widget-button-white.svg";

const ExpansionPanel = withStyles({
    root: {
        padding: 0,
        backgroundColor: '#4b4e56',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0
        },
        '&:before': {
            display: 'none',
            padding: 0
        },
        '&$expanded': {
            margin: 'auto',
            padding: 0
        },
    },
    expanded: {},
})(MuiExpansionPanel);
const ExpansionPanelSummary = withStyles({
    root: {
        marginBottom: -1,
        minHeight: 56,
        padding: 0,
        '&$expanded': {
            padding: 0,
            minHeight: 56,
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
    expandIcon: {}
})(MuiExpansionPanelSummary);
const ExpansionPanelDetails = withStyles(theme => ({
    root: {
        padding: theme.spacing(2)
    },
}))(MuiExpansionPanelDetails);

const SeriesLinesInterfacesConfigField =
    ({
         seriesIndex,
         lineIndex,
         lineElem,
         entityList,
         terminalsListByEntityId,
         interfacesListByEntityId,
         interfacesListByTerminalId,

         categorySelected,
         resolutionAggregator,

         //handlers
         handleEntityChangeInSeries,
         handleTerminalChangeInSeries,
         handleInterfaceChangeInSeries,
         handleAddInterfaceToSeriesLineClicked,
         handleDeleteInterfaceOfSeriesLineClicked
     }) => {

        const [expandedArray, setExpanded] = React.useState(["series_" + seriesIndex + "_line_0_interfaces"]);
        const handleChange = panel => (event, isExpanded) => {
            if(isExpanded) {
                setExpanded([
                    ...expandedArray,
                    panel
                ]);
            } else {
                setExpanded(expandedArray.filter( v => v !== panel));
            }
        };

        const key = "series_" + seriesIndex + "_line_" + lineIndex + "_interfaces";
        const hasCategoryDefined = !_.isNilOrEmpty(lineElem) && !_.isNilOrEmpty(lineElem.interfaceCategory);

        return (
            <div className="line-element-interfaces-wrapper"> {/*Interfaces groups wrapper*/}
                <ExpansionPanel expanded={expandedArray.indexOf(key) !== -1  && hasCategoryDefined } onChange={handleChange(key)}>
                    <ExpansionPanelSummary
                        id={key + "d-header"}
                        aria-controls={key + "d-content"}
                        expandIcon={
                            <IconButton
                                alt="delete"
                                image={arrowDownWhite}
                                handleIconClick={() => handleChange(key)}
                            />
                        }
                    >
                        <div className="interfaces-title">
                            <span><b>{I18n.t("dashboard.widgets.formsFields.chartSeries.interfaces")}</b></span>
                            <span className="interfaces-title-secondary-text">{getWarningMessage(categorySelected, resolutionAggregator)}</span>
                        </div>
                    </ExpansionPanelSummary>

                    <ExpansionPanelDetails>

                        <div className="line-element-interface-elements">
                            {
                                hasCategoryDefined &&
                                lineElem.interfaces.map((interfaceElem, interfaceIndex) => {
                                    const {
                                        entityId,
                                        terminalId,
                                        interfaceId
                                    } = interfaceElem;
                                    return (
                                        /*Interfaces group element*/
                                        <div key={"series_" + seriesIndex + "_line_" + lineIndex + "_interface_" + interfaceIndex} className="row line-element-interface-element">
                                            {/*Entity*/}
                                            <SelectField
                                                themeName="white"
                                                label={I18n.t("dashboard.widgets.formsFields.chartSeries.labels.entity")}
                                                value={entityId}
                                                handleFieldChange={value => handleEntityChangeInSeries(seriesIndex, lineIndex, interfaceIndex, value)}
                                                options={entityList}
                                                white={true}
                                                width={3}
                                            />
                                            {/*Terminal*/}
                                            <SelectField
                                                themeName="white"
                                                label={I18n.t("dashboard.widgets.formsFields.chartSeries.labels.terminal")}
                                                value={interfaceElem.terminalId}
                                                handleFieldChange={value => handleTerminalChangeInSeries(seriesIndex, lineIndex, interfaceIndex, value)}
                                                options={
                                                    !_.isNilOrEmpty(entityId) &&
                                                    !_.isNilOrEmpty(terminalsListByEntityId[entityId]) ?
                                                        terminalsListByEntityId[entityId] :
                                                        []
                                                }
                                                width={3}
                                            />
                                            {/*Interface*/}
                                            <SelectField
                                                themeName="white"
                                                label={!_.isNilOrEmpty(entityId) ?
                                                    !_.isNilOrEmpty(terminalId) ?
                                                        I18n.t("dashboard.widgets.formsFields.chartSeries.labels.terminalInterface") :
                                                        I18n.t("dashboard.widgets.formsFields.chartSeries.labels.entityInterface") :
                                                    I18n.t("dashboard.widgets.formsFields.chartSeries.labels.interface")}
                                                value={interfaceId}
                                                handleFieldChange={value => handleInterfaceChangeInSeries(seriesIndex, lineIndex, interfaceIndex, value)}
                                                options={getOptionsForInterfaceList(entityId, terminalId, lineElem.interfaceCategory, interfacesListByEntityId, interfacesListByTerminalId)}
                                                width={3}
                                            />
                                            {/*Delete interface group button*/}
                                            <div className="remove-interface-button" style={{opacity: (interfaceIndex === 0) ? '0.5' : '1'}}>
                                                <IconButton
                                                    alt="delete"
                                                    disabled={interfaceIndex === 0}
                                                    image={deleteButton}
                                                    handleIconClick={(e) => {
                                                        e.stopPropagation();
                                                        handleDeleteInterfaceOfSeriesLineClicked(seriesIndex, lineIndex, interfaceIndex)
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    );
                                })
                            }
                            {/*Add Line Button*/}
                            <div className="add-interface-button" onClick={() => handleAddInterfaceToSeriesLineClicked(seriesIndex, lineIndex)}>
                                <IconButton
                                    alt="addLine"
                                    selected={false}
                                    image={addButton}
                                    classes="mr-2"
                                />
                                <b>{I18n.t('dashboard.widgets.formsFields.chartSeries.labels.addInterface')}</b>
                            </div>
                        </div>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            </div>
        );
    };

const getOptionsForInterfaceList = (entityId, terminalId, interfaceCategory, interfacesListByEntityId, interfacesListByTerminalId) => {
    if (!_.isNilOrEmpty(entityId)) {
        if (!_.isNilOrEmpty(terminalId) && !_.isNilOrEmpty(interfacesListByTerminalId[terminalId])) {
            return interfacesListByTerminalId[terminalId].filter(iface => iface.category === interfaceCategory);
        }
        if (!_.isNilOrEmpty(interfacesListByEntityId[entityId])) {
            return interfacesListByEntityId[entityId].filter(iface => iface.category === interfaceCategory);
        }
    }
    return [];
};

const getWarningMessage = (categorySelected, resolutionAggregator) => {
    if (_.isNilOrEmpty(categorySelected)) {
        return I18n.t("dashboard.widgets.formsFields.chartSeries.chooseInterfaceCategory");
    }
    if(resolutionAggregator === 'ALL_VALUES') {
        return I18n.t("dashboard.widgets.formsFields.chartSeries.warningAllValues");
    }
};


export default SeriesLinesInterfacesConfigField;